import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ONGLETS from "./onglet";
import MENU_EMOLACTES from "./menu_emolActes";
import EMOL from "./emol";
import EMOL_FORM from "./emol_form";
import MENU_FISCA from "./menu_fisca";
import FISCA from "./fisca";
import MENU_DROITSFIXES from "./menu_droitsFixes";
import DROITSFIXES from "./droits_fixes";
import DEBOURS from "./debours";
import FichesPratiques from "./fichesPratiques";
import "./essentiel.css";
import ModalComponent from "./modalIntroFisca";
import {useForceUpdate} from "../../config";
import PenLoader from "../../components/loaders/PenLoader";
import jwt_decode from "jwt-decode";

const ASYNC_ESSENTIEL_TABS = new Set([
  "ÉMOLUMENTS D’ACTES",
  "ÉMOLUMENTS DE FORMALITÉS",
  "Fiscalité",
  "Droits fixes (rappel)",
]);

const SECTIONED_LOADING_TABS = new Set([
  "ÉMOLUMENTS D’ACTES",
  "Fiscalité",
  "Droits fixes (rappel)",
]);

const ESSENTIEL = () => {
  const location = useLocation();
  const initialUserRef = useRef(localStorage.getItem("user"));
  const [activeItem, setActiveItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [activeFiscaItem, setActiveFiscaItem] = useState(null);
  const [selectedFiscaItems, setSelectedFiscaItems] = useState([]);
  const [activeFixesItem, setActiveFixesItem] = useState(null);
  const [selectedFixesItems, setSelectedFixesItems] = useState([]);
  const [menuFixesItems] = useState([]);
  // const [activeTab, setActiveTab] = useState("ÉMOLUMENTS D’ACTES");
  const [simulateurResponses, setSimulateurResponses] = useState({});
  const [menuItems] = useState([]);  

  var forceUpdate = useForceUpdate();

  // useEffect(() => {
  //   if (activeTab === "ÉMOLUMENTS D’ACTES") {
  //     if (!activeItem && menuItems.length > 0) {
  //       setActiveItem(menuItems[0], menuItems[1]);
  //       setSelectedItems([menuItems[0]], [menuItems[1]]);
  //     }
  //   }
  // }, [activeTab, menuItems, activeItem]);

  const hashToTabMap = {
    emolActes: "ÉMOLUMENTS D’ACTES",
    emolForm: "ÉMOLUMENTS DE FORMALITÉS",
    fisca: "Fiscalité",
    droitsFixes: "Droits fixes (rappel)",
    debours: "Débours",
    fichesPratiques: "Fiches pratiques"
  };

  const arrayToHashTabMap =  [
    "emolActes",
    "fisca",
    "droitsFixes"
  ]

  const initialHash = location.hash.substring(1);
  const initialTab = hashToTabMap[initialHash] || "ÉMOLUMENTS D’ACTES"; // Utiliser le fragment si présent, sinon la valeur par défaut
  const [activeTab, setActiveTab] = useState(initialTab);
  const [currentTabFromURL, setCurrentTabFromURL] = useState([])
  const [isLoading, setIsLoading] = useState(() => ASYNC_ESSENTIEL_TABS.has(initialTab));
  const activeTabRef = useRef(initialTab);

  const isStoredJwtExpired = () => {
    try {
      const jwt = JSON.parse(localStorage.getItem("user"))?.jwt;

      if (!jwt) {
        return true;
      }
      const { exp } = jwt_decode(jwt);
      return !Number.isFinite(exp) || exp * 1000 <= Date.now();
    } catch (error) {
      return true;
    }
  };

  const handleExpiredSession = () => {
    if (isStoredJwtExpired() || localStorage.getItem("user") !== initialUserRef.current) {
      localStorage.removeItem("user");
      sessionStorage.setItem("session_expired", "true");
      window.location.replace("/login");
      return true;
    }

    return false;
  };

  const handleNavigationClickCapture = (event) => {
    const target = event.target.closest(".li_essentiel, .alphabet-letter, .menu-item");

    if (!target || !handleExpiredSession()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
  };

  useEffect(() => {
    activeTabRef.current = activeTab;
    setIsLoading(ASYNC_ESSENTIEL_TABS.has(activeTab));
  }, [activeTab]);

  const markTabReady = (tabName) => {
    if (activeTabRef.current !== tabName) {
      return;
    }
    setIsLoading(false);
  };

  const renderLoadingContent = () => {
    if (SECTIONED_LOADING_TABS.has(activeTab)) {
      return (
        <div className="essentiel_content_loading essentiel_content_loading--split" aria-live="polite">
          <div className="essentiel_loading_panel essentiel_loading_panel--sidebar">
            <PenLoader compact className="essentiel_section_pen_loader" />
          </div>
          <div className="essentiel_loading_panel essentiel_loading_panel--content">
            <PenLoader compact className="essentiel_section_pen_loader" />
          </div>
        </div>
      );
    }

    return (
      <div className="essentiel_content_loading essentiel_content_loading--full" aria-live="polite">
        <div className="essentiel_loading_panel essentiel_loading_panel--full">
          <PenLoader compact className="essentiel_section_pen_loader" />
        </div>
      </div>
    );
  };
  

  useEffect(() => {
    // Ce code permet de rediriger automatiquement vers l'onglet choisi par la barre de recherche.
    // Le formatage est le suivant : #X#X
    // Le premier # correspond à l'onglet (0 pour ÉMOLUMENTS D’ACTES, 1 pour Fiscalité, 2 pour Droits fixes)
    // Le second # correspond à l'acte
    const hash = location.hash.substring(1);
    const hashParts = hash.split("#");
    const [tabIndex, rowTarget] = hashParts;
    const hasIndexedTarget = !isNaN(tabIndex) && rowTarget !== undefined && rowTarget !== "";

    if (hasIndexedTarget) {
      const tab = hashToTabMap[arrayToHashTabMap[tabIndex]];
      if (tab) {
        setActiveTab(tab);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      setCurrentTabFromURL(hashParts);
      forceUpdate();
      return;
    }

    setCurrentTabFromURL([]);

    const tab = hashToTabMap[hash];
    if (tab) {
      setActiveTab(tab);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.hash, forceUpdate]);
  

  const renderContent = () => {
    switch (activeTab) {
      case "ÉMOLUMENTS D’ACTES":
        return (
          <>
            <MENU_EMOLACTES
              setActiveItem={setActiveItem}
              currentTabFromURL={currentTabFromURL}
              setSelectedItems={setSelectedItems}
              setSimulateurResponses={setSimulateurResponses}
              activeItem={activeItem}
              onReady={() => markTabReady("ÉMOLUMENTS D’ACTES")}
            />
            <EMOL
              activeItem={activeItem}
              selectedItems={selectedItems}
              simulateurResponses={simulateurResponses}
              setSimulateurResponses={setSimulateurResponses}
              menuItems={menuItems}
              setActiveItem={setActiveItem}
              setSelectedItems={setSelectedItems}
            />
          </>
        );
      case "ÉMOLUMENTS DE FORMALITÉS":
        return <EMOL_FORM onReady={() => markTabReady("ÉMOLUMENTS DE FORMALITÉS")} />;
      case "Fiscalité":
        return (
          <>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ModalComponent />
              <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", borderTop: "1px solid #016954" }}>
                <MENU_FISCA
                  setActiveFiscaItem={setActiveFiscaItem}
                  currentTabFromURL={currentTabFromURL}
                  setSelectedFiscaItems={setSelectedFiscaItems}
                  activeFiscaItem={activeFiscaItem}
                  onReady={() => markTabReady("Fiscalité")}
                />
                <FISCA
                  menuItems={menuItems}
                  activeFiscaItem={activeFiscaItem}
                  setActiveFiscaItem={setActiveFiscaItem}
                  selectedFiscaItems={selectedFiscaItems}
                  setSelectedFiscaItems={setSelectedFiscaItems}
                />
              </div>
            </div>
          </>
        );
      case "Droits fixes (rappel)":
        return (
          <>
            <MENU_DROITSFIXES
              setActiveFixesItem={setActiveFixesItem}
              currentTabFromURL={currentTabFromURL}
              setSelectedFixesItems={setSelectedFixesItems}
              activeFixesItem={activeFixesItem}
              onReady={() => markTabReady("Droits fixes (rappel)")}
            />
            <DROITSFIXES
              menuFixesItems={menuFixesItems}
              activeFixesItem={activeFixesItem}
              setActiveFixesItem={setActiveFixesItem}
              selectedFixesItems={selectedFixesItems}
              setSelectedFixesItems={setSelectedFixesItems}
            />
          </>
        );
      case "Débours":
        return <DEBOURS />;
      case "Fiches pratiques":
        return <FichesPratiques />;
      default:
        return null;
    }
  };

  return (
    <div className="essentiel_page_root">
      <div className="essentiel_page_shell">
        <div className="essentiel_page_content essentiel_page_content--visible">
          <div className="essentiel" onClickCapture={handleNavigationClickCapture}>
            <ONGLETS activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className={`essentiel_content_shell ${isLoading ? "essentiel_content_shell--loading" : ""}`}>
              <div
                className={`essentiel_container ${isLoading ? "essentiel_container--loading" : ""}`}
                aria-hidden={isLoading ? "true" : "false"}
              >
                {renderContent()}
              </div>
              {isLoading ? renderLoadingContent() : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ESSENTIEL;
